/**
 * Speed changes along a piece: from `at` (quarter notes) the music moves at `factor` × the tempo.
 * `warp` turns a position into quarter notes at the base tempo (a passage at half speed counts
 * double); `unwarp` turns it back. Both assume the map is sorted by position.
 */
export type TempoMap = Array<{ at: number; factor: number }>;

export function warp(map: TempoMap, pos: number): number {
  let w = 0;
  let prev = 0;
  let f = 1;
  for (const seg of map) {
    if (seg.at >= pos) break;
    w += (seg.at - prev) / f;
    prev = seg.at;
    f = seg.factor;
  }
  return w + (pos - prev) / f;
}

export function unwarp(map: TempoMap, w: number): number {
  let acc = 0;
  let prev = 0;
  let f = 1;
  for (const seg of map) {
    const span = (seg.at - prev) / f;
    if (acc + span >= w) break;
    acc += span;
    prev = seg.at;
    f = seg.factor;
  }
  return prev + (w - acc) * f;
}
